<template>
  <div id="standard">
    <sport
      v-for="sport in sports"
      :key="sport.id"
      :sport="sport"
    />
  </div>
</template>

<script>
import { each } from 'lodash';
import Sport from './Sport.vue';

export default {
  name: 'StandardPlus',
  components: { Sport },
  data() {
    return {
      rowCountMax: 19,
    };
  },
  computed: {
    sports() {
      let rowCount = 0;

      const sportsToDisplay = [];
      let loop = true;
      each(this.$store.getters.activeSports, (activeSport) => {
        if (!loop) return;
        if (rowCount >= this.rowCountMax - 1) {
          loop = false;
          return;
        }

        const sport = activeSport;
        sportsToDisplay.push(sport);

        // Count how many matches needs to be spliced from last sport
        const betSection = this.$store.state.live.templateGrid.betsSections[sport.id];
        this.$set(sport, 'bets', this.$store.getters.getActiveSportBetsFromSections(betSection));
        this.$set(sport, 'matchIds', []);
        rowCount += 1; // Sport header

        each(this.$store.getters.getSportMatchIds(sport.id), (idMatch) => {
          const match = this.$store.getters.getMatch(idMatch);
          rowCount += match.status.isFirstPeriod && match.templateInfo ? 2 : 1;

          if (rowCount > this.rowCountMax) {
            loop = false;
            return;
          }
          sport.matchIds.push(match.id);
        });
      });

      return sportsToDisplay;
    },
  },
};
</script>
